module.exports = __webpack_public_path__ + "Frame389-8e017f38.webp";